import {useTranslation} from "ni18n";
import React from "react";
import {getAllowedLocationsToRender} from "src/constants/locations";
import {useTypedSelector} from "src/store";

import Layout from "../../components/v5/Layout";
import LocationMapForLocations from "../../components/v5/LocationMapForLocations";

type Props = {
  state?: string;
  city?: string;
};

const LocationsIndex: React.FC<Props> = () => {
  const i18n = useTranslation();
  const {locations} = useTypedSelector(({config}) => config);

  const renderableLocations = getAllowedLocationsToRender(locations);

  const pageTitle = i18n.t("Find a Carbon Health Urgent Care & Primary Care Provider Near You");
  const pageDescription = i18n.t(
    "Find an Adult or Pediatric Urgent Care or Primary Care provider near you. Book online for the fastest experience but walk-ins are always welcome.",
  );

  return (
    <Layout
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage="location-search"
      pageImageExt="gif"
      ogAlt={i18n.t("Find a Carbon Health location near you.")}
      navStartTransparent={false}
    >
      <LocationMapForLocations locations={renderableLocations} />
    </Layout>
  );
};

export default LocationsIndex;
